import React, { Component } from "react"
import Select from "react-select"
import EALAService from "../Utils/EALAService"
import AccessLevelTypes from "../Types/AccessLevelTypes"
import ConfirmUpdateUserType from "./ConfirmUpdateUserType/ConfirmUpdateUserType"
import mutator from "src/utilities/mutator"
import "./UpdateUserType.css"

interface Props {
    callParentFunction: Function
    AccessLevelID: number
    isNaughty: boolean
}

interface State {
    confirmUpdateUserType: boolean
    newAccessLevelID: number
}

class UpdateUserType extends Component<Props, State> {
    state = {
        confirmUpdateUserType: false,
        newAccessLevelID: -1
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: { key: string, value?: any }[]) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    render() {

        const { callParentFunction, AccessLevelID, isNaughty } = this.props
        const { confirmUpdateUserType, newAccessLevelID } = this.state
        const { reference, getSelectedAccessLevelByID } = EALAService
        const accessLevels = reference.accessLevels

        return (
            <div className="UpdateUserType">
                <Select
                    placeholder={"End user"}
                    value={{ label: getSelectedAccessLevelByID(newAccessLevelID > -1 ? newAccessLevelID : AccessLevelID, accessLevels).accessDesc }}
                    options={accessLevels.map((accessLevel) => ({ value: accessLevel, label: accessLevel.accessDesc }))}
                    onChange={(item: { label: string, value: AccessLevelTypes }) => {
                        const newID = item.value.accessLevelID
                        if (newID !== AccessLevelID) {
                            this.manageState([{ key: "confirmUpdateUserType", value: true }, { key: "newAccessLevelID", value: newID }])
                        }
                    }}
                    isDisabled={isNaughty}
                />
                {confirmUpdateUserType &&
                    <ConfirmUpdateUserType
                        manageParentState={this.manageState}
                        callParentFunction={callParentFunction}
                        newAccessLevelID={newAccessLevelID}
                        oldAccessLevelID={AccessLevelID}
                    />
                }
            </div>
        )
    }
}

export default UpdateUserType